import { render, staticRenderFns } from "./abroadlogistics-edit.vue?vue&type=template&id=c0e5d4aa&"
import script from "./abroadlogistics-edit.vue?vue&type=script&lang=ts&"
export * from "./abroadlogistics-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports